<template>
  <transition
    name="modal"
    appear
  >
    <div
      class="modal modal-overlay"
      @click="closeModal($event)"
    >
      <div class="modal-window">
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  methods: {
    closeModal(e) {
      if (e.target.className === "modal modal-overlay") {
        this.$emit("close");
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
}


.modal-enter-active, .modal-leave-active {
  transition: opacity 0.4s;

  .modal-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter, .modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
